<template>
    <div class="main-container">
        <div class="container-services-first">
            <h2 class="main-title"><router-link :to="{ name: $t('otherServicesRouteName') }">{{ $t("services")
            }}</router-link></h2>
            <div id="item-services-first-list" class="grid-view item-services-first-list">
                <div v-for="item in servicesList" :key="item.id" class="services-first-element">
                    <div class="services-first-text">
                        <router-link :to="{ name: $t('otherServicesRouteName') }">
                            <h2>{{ item.name }}</h2>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            servicesList: [{ id: 1, name: this.$t("otherServicesTitle1"), content: this.$t("otherServicesText1") },
            { id: 2, name: this.$t("otherServicesTitle2"), content: this.$t("otherServicesText2") },
            { id: 3, name: this.$t("otherServicesTitle3"), content: this.$t("otherServicesText3") },
            { id: 4, name: this.$t("otherServicesTitle4"), content: this.$t("otherServicesText4") }]
        }
    },
    computed: {
        ...mapGetters(["getChildrenByParentId", "getSelectedLanguage"]),
    },
    methods: {
        loadList() {
            this.servicesList = [{ id: 1, name: this.$t("otherServicesTitle1"), content: this.$t("otherServicesText1") },
            { id: 2, name: this.$t("otherServicesTitle2"), content: this.$t("otherServicesText2") },
            { id: 3, name: this.$t("otherServicesTitle3"), content: this.$t("otherServicesText3") },
            { id: 4, name: this.$t("otherServicesTitle4"), content: this.$t("otherServicesText4") }]
        }
    },
    watch: {
        getSelectedLanguage() {
            this.loadList();
        }
    },
}
</script>

<style scoped>
.main-container {
    padding: 0 7% 3rem;
    width: 100%;
}

.main-title {
    color: var(--main-color);
    font-size: 30px;
    font-weight: 600;
    cursor: pointer;
}

.container-services-first {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    background-color: var(--light-color);
}

.services-first {
    padding: 2% 7% 2% 7%;
    background-color: var(--light-color);
}

.services-first::after {
    padding: 2% 7% 2% 7%;
}

.services-first-element {
    border-radius: .5rem;
    background-color: var(--main-color);
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.services-first-element:hover {
    transform: scale(1.02);
}

.grid-view {
    display: grid;
    gap: 20px;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 1fr;
}


.services-first-text {
    height: 100%;
    width: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
}

.services-first-text router-link {
    text-decoration: none;
}

.services-first-text:hover router-link,
.services-first-text:hover a {
    text-decoration: none;
}

.services-first-text h2 {
    font-size: 26px;
    color: #fff;
    font-weight: 500;
    margin-bottom: 0;
}

.services-first-text-p {
    max-height: 300px;
    color: var(--light-color);
    text-align: justify;
    font-size: 18px;
    line-height: 1.8;
    margin-bottom: 20px;
    padding-right: 15px;
}

.services-first-text-p a {
    color: var(--light-color);
    text-decoration: underline;
    font-weight: bold;
}


.main-title a {
    color: var(--main-color);
    text-decoration: none;
}

@media only screen and (max-width: 700px) {
    .grid-view {
        grid-template-columns: repeat(1, 1fr);
    }

    .services-first-element {
        padding: 5%;
        width: 100%;
        min-width: unset;
    }

}
</style>
